import "./src/styles/global.css"

import wrapWithProvider from './wrap-with-provider'
export const wrapRootElement = wrapWithProvider

export const onRouteUpdate = (
  { location }
) => {
  const domElem = document.querySelector(`link[rel='canonical']`)
  const existingValue = domElem.getAttribute(`href`)
  const baseProtocol = domElem.getAttribute(`data-baseProtocol`)
  const baseHost = domElem.getAttribute(`data-baseHost`)
  if (existingValue && baseProtocol && baseHost) {
    const pathname = location.pathname.endsWith('/') ? location.pathname : location.pathname + '/'
    let value = `${baseProtocol}//${baseHost}${pathname}${location.hash}`
    domElem.setAttribute(`href`, `${value}`)
  }
}
